// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import router from './router'
import 'weui'
import wejs from 'weui.js'
import './filters'
import './plugins'
import * as PublicComponents from './public-lib/vue-components/src/components'
import './assets/scss/app.scss'
import './directives'
import FastClick from 'fastclick'
import store from './store'
import axios from 'axios'
import Cookies from 'js-cookie'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
Vue.use(PublicComponents)
Vue.use(VueAwesomeSwiper)
FastClick.attach(document.body)

Vue.config.productionTip = false

Object.defineProperty(Vue.prototype, '$wejs', {
  get () {
    return wejs
  }
})
// 处理 http://register.fe.yuanbei.biz/?code=011PcG8O0hZU2426588O0xwT8O0PcG85&state=#/author这种情况
router.beforeEach(async (to, from, next) => {
  // URL解析 微回调地址中code存在 ?....# 中
  if (document.URL.match(/\?.*#/)) {
    let temp = document.URL.match(/\?.*#/)[0]
    if (temp.match(/=.*&/)) {
      // 解析Code
      let code = temp.match(/=.*&/)[0]
      code = code.substr(1, code.length) // 去掉 ?
      code = code.substr(0, code.length - 1)  // 去掉 #
      // 重置URL(去掉code参数，避免重复调用)
      window.history.pushState({}, 0, document.URL.replace(temp.substr(0, temp.length - 1), ''))
      // 区分是分享和人脉提现
      if (/(http):\/\/register.fe.yuanbei.biz/g.test(document.URL)) { // 人脉提现
        let json = await axios.get(`http://shengyi-helper.i200.cn/oauth2/UserInfoCallback?code=${code}`)
        Cookies.set('openId', json.data.openId)
        Cookies.set('headimgurl', json.data.headimgurl)
        Cookies.set('nickname', json.data.nickname)
      } else if (/(http):\/\/fe-boss-image.yuanbei.biz/g.test(document.URL)) { // boss image分享
        let json = await axios.get(`http://boss-image.yuanbei.biz/OAuth2/UserInfoCallback?code=${code}`)
        Cookies.set('openIdBoss', json.data.openId)
        Cookies.set('headimgurlBoss', json.data.headimgurl)
        Cookies.set('nicknameBoss', json.data.nickname)
        !json.data.openId && Cookies.set('failBoss', 1)
      }
    }
  }
  next()
})

/* eslint-disable no-new */
new Vue({
  store,
  router
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js